/** Returns a tracked-number updater that publishes the fieldsets after updating the form. */
export function createTrackedNumberUpdate(manager, notify) {
  return async function updateTrackedNumber(number, params) {
    Object.assign(params, { original_number: number });
    const numberData = Object.assign(manager.numbers[number] ?? {}, params);
    manager.numbers[number] = numberData;

    if (!numberData.fieldset_id) {
      numberData.fieldset_id = numberData.tracked_number_id || new Date().getTime();
    }

    await manager.updateForm(number);
    notify("update", manager.getFieldsets());
  };
}
